import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import StageTime from 'modules/journey/stop-status-log/stage-time';
import StageVoid from 'modules/journey/stop-status-log/stage-void';
import StageWarning from 'modules/journey/stop-status-log/stage-warning';
import StageActions from 'modules/journey/stop-status-log/stage-actions';
import StageLoading from 'modules/journey/stop-status-log/stage-loading';
import StageEstimatedTime from 'modules/journey/stop-status-log/stage-eta';

const StopStatusLogStage = ({
  handleClick,
  className,
  stage,
  handleMouseEnter,
  handleMouseLeave,
  isOver,
  isOpened,
  isLoading,
  isClickable,
  setParentRef,
  stopId,
  journeyId,
  actionSource,
  debugWarningOnTop,
}) => {
  const timeDoneComponent = <StageTime stage={stage} journeyId={journeyId} stopId={stopId} />;

  const warningComponent = (
    <StageWarning
      stage={stage}
      journeyId={journeyId}
      stopId={stopId}
      over={isOver}
      clickable={isClickable}
      opened={isOpened}
      debugWarningOnTop={debugWarningOnTop}
    />
  );

  const voidComponent = <StageVoid clickable={isClickable} />;

  return (
    <div
      data-e2e={`journey_detail__show_advanceJourney_clickable=${isClickable}`}
      onClick={handleClick}
      className={cx(className, {
        'StopStatusLogStage-clickable': isClickable,
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={setParentRef}
    >
      {isLoading && isClickable && <StageLoading />}

      {warningComponent}
      {timeDoneComponent}

      <StageEstimatedTime
        stage={stage}
        journeyId={journeyId}
        stopId={stopId}
        over={isOver}
        opened={isOpened}
        clickable={isClickable}
      />

      {isClickable && !isLoading && (
        <StageActions
          stage={stage}
          journeyId={journeyId}
          stopId={stopId}
          over={isOver}
          opened={isOpened}
          actionSource={actionSource}
        />
      )}

      {voidComponent}
    </div>
  );
};

StopStatusLogStage.propTypes = {
  handleClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  stage: PropTypes.string.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  isOpened: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setParentRef: PropTypes.func,
  isClickable: PropTypes.bool.isRequired,
  stopId: PropTypes.number.isRequired,
  journeyId: PropTypes.number.isRequired,
  actionSource: PropTypes.string.isRequired,
  debugWarningOnTop: PropTypes.bool.isRequired,
};

StopStatusLogStage.defaultProps = {
  handleClick: () => {
    /*noop*/
  },
  isClickable: false,
  debugWarningOnTop: false,
};

export default memo(StopStatusLogStage);
